import { useMediaQuery } from '@mui/material';
import { current } from '@reduxjs/toolkit';
import React, { PureComponent } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';


const COLORS = [
    '#3363FF', // Royal Blue
    '#33B0FF', // Sky Blue
    '#33FFAA', // Light Green
    '#33FFCC', // Cyan
    '#33E7FF', // Light Blue
    '#FFBD33', // Yellow
    '#FF5733', // Dark Orange
    '#FFC733', // Mustard Yellow
    '#FFE333', // Light Yellow
    '#33FF33', // Lime Green
    '#33A0FF', // Azure
    '#33FF6F', // Sea Green
    '#FF33A8', // Pinkish Purple
    '#33C5FF', // Teal
    '#FFA933', // Orange
    '#FF33D7', // Magenta
    '#33FF4C', // Spring Green
    '#FF33F5', // Fuchsia
];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
        <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
            {`${(percent * 100).toFixed(0)}%`}
        </text>
    );
};

export default function CumulativeChart({data}) {

    let isSmallScreen = useMediaQuery('(max-width: 600px)');

    if(!data) return;

    if (isSmallScreen) return null;

    let sorted = [...data].sort(function (a, b) {
        return b.count - a.count;
    });

    let top = 6;

    if(sorted.length > top) {
        let rem = sorted.slice(top);
        let count = rem.reduce((acc, curr) => {
            return acc + curr.count
        }, 0);
        sorted = sorted.slice(0, top);
        sorted.push({
            contestant: 'Others',
            count
        });
        console.log(sorted);
    }

    

    let chartD = isSmallScreen ? 400 : 600;
    let chartR = isSmallScreen ? 150 : 200;


    return (
        <ResponsiveContainer width="100%" >
            <PieChart width={chartD} height={chartD}>
                <Pie
                    data={sorted}
                    cx="50%"
                    cy="50%"
                    // labelLine={false}
                    // label={renderCustomizedLabel}
                    label
                    outerRadius={chartR}
                    dataKey="count"
                    nameKey="contestant"
                >
                    {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                </Pie>
                <Tooltip/>
            </PieChart>
        </ResponsiveContainer>
    );
}